module.exports = __webpack_public_path__ + "img/08.22.30.256ac079.jpg";